export default "__VITE_ASSET__B1gZ90IV__"